import MembersFlatTable from './MembersFlatTable.component';

export default MembersFlatTable;
